import { Paper, Stack } from "@mui/material";
import { colors } from "@/styles/constants";

export type RequiredHeaderProps = {
  title: string;
  showError: boolean;
  optional?: boolean;
};

export const RequiredHeader: React.FC<RequiredHeaderProps> = ({ showError, title, optional }) => {
  if (optional) {
    return <OptionalHeader title={title} />;
  }
  return (
    <Stack flexGrow={1} direction="row" justifyContent="space-between" alignItems="baseline">
      <b style={{ color: colors.bodyText }}>{title}</b>
      {showError && (
        <Paper
          elevation={0}
          sx={{
            backgroundColor: colors.offWhite,
            padding: "4px 32px",
            marginRight: "16px",
            color: colors.errorRed,
          }}
        >
          Required
        </Paper>
      )}
    </Stack>
  );
};

export type OptionalHeaderProps = {
  title: string;
};

export const OptionalHeader: React.FC<OptionalHeaderProps> = ({ title }) => {
  return (
    <Stack flexGrow={1} direction="row" justifyContent="space-between" alignItems="baseline">
      <b style={{ color: colors.bodyText }}>{title}</b>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: colors.offWhite,
          padding: "4px 32px",
          marginRight: "16px",
        }}
      >
        Optional
      </Paper>
    </Stack>
  );
};
